/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Workflows/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Workflows({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Workflows",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Workflows.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1ekdo2': alignSelf,'--mt-2-Z1ekdo2': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1ekdo2': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1ekdo2': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1ekdo2': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1ekdo2': opacity,'--w-10-Z1ekdo2': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1ekdo2': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1ekdo2': fill,'--a-7-Z1ekdo2': isAnimated ? animation : "none",'--sd-8-Z1ekdo2': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1ekdo2': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Workflows.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.066 2.21a.714.714 0 011.01 0l2.858 2.856a.714.714 0 010 1.01l-2.47 2.47V12h1.25a.714.714 0 01.505 1.22l-2.142 2.142a.712.712 0 01-.505.21h1.07c1.184 0 2.144.959 2.144 2.142v.179H12v-1.25a.714.714 0 011.22-.505l2.142 2.143a.714.714 0 010 1.01l-2.143 2.143A.715.715 0 0112 20.929v-1.25H8.786v.178c0 1.184-.96 2.143-2.143 2.143H4.5a2.143 2.143 0 01-2.143-2.143v-2.143c0-1.183.96-2.143 2.143-2.143h1.072a.715.715 0 01-.506-.209L2.924 13.22A.714.714 0 013.429 12h1.25V8.546l-2.47-2.47a.714.714 0 010-1.01L5.066 2.21zm13.72.147a3.214 3.214 0 11-3.089 4.107h-2.983v1.25a.714.714 0 01-1.22.505L9.353 6.077a.714.714 0 010-1.01l2.143-2.143a.714.714 0 011.22.505v1.25h2.982a3.216 3.216 0 013.089-2.322zM22 18.786a3.214 3.214 0 10-6.429 0 3.214 3.214 0 006.429 0z"
 style={{'--f-12-Z1ekdo2': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}